import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import {colors} from '../colors/colors';
import {ChevronRightIcon, TickCircleIcon} from '../icon';

import styles from './checklist-card.module.css';

type Props = {
    title: string;
    subtitle?: string | null | undefined;
    isComplete: boolean;
    onClick: () => void;
};

export function ChecklistCard(props: Props) {
    return (
        <ButtonCard isFullWidth={true} onClick={props.onClick}>
            <div className={styles.container}>
                <div className={styles.content}>
                    <div className='mr-16'>
                        {props.isComplete ? (
                            <TickCircleIcon size={16} color={colors.green} alignCenter={true} />
                        ) : (
                            <div className={styles['incomplete-circle']}></div>
                        )}
                    </div>
                    <div className={styles.titles}>
                        <div className='font-bold font-size-normal'>{props.title}</div>
                        {props.isComplete || !props.subtitle ? undefined : (
                            <div className={styles.subtitle}>{props.subtitle}</div>
                        )}
                    </div>
                </div>
                <div className={styles.arrow}>
                    <ChevronRightIcon />
                </div>
            </div>
        </ButtonCard>
    );
}
